import { useQuery } from '@tanstack/react-query';

import { BillingGroup, BillingGroupHistory, DateStr, FeeType, GUID } from '@ndvr/billing-api';

import { BillingApi } from 'API';

const BillingGroupHistoryQueryKeys = {
    byRange: (billingGroupGUID: GUID<BillingGroup>, startDate?: DateStr, endDate?: DateStr, feeType?: FeeType) =>
        ['billingGroupHistory', billingGroupGUID, startDate ?? null, endDate ?? null, feeType ?? null] as const,
};

export const useBillingGroupHistory = (
    billingGroupGUID: GUID<BillingGroup>,
    startDate?: DateStr,
    endDate?: DateStr,
    feeType?: FeeType,
) =>
    useQuery({
        queryKey: BillingGroupHistoryQueryKeys.byRange(billingGroupGUID, startDate, endDate, feeType),
        queryFn: async (): Promise<BillingGroupHistory | undefined> => {
            const [response] = await BillingApi().getBillingGroupHistory(billingGroupGUID, {
                startDate,
                endDate,
                feeType,
            });
            return response ?? undefined;
        },
    });
